import { inlines } from './inlines';
var supportedLanguageInWiki = ['actionscript', 'ada', 'applescript', 'bash', 'c', 'c#', 'c++', 'cpp', 'css', 'erlang', 'go', 'groovy', 'haskell', 'html', 'java', 'javascript', 'js', 'json', 'lua', 'none', 'nyan', 'objc', 'perl', 'php', 'python', 'r', 'rainbow', 'ruby', 'scala', 'sh', 'sql', 'swift', 'visualbasic', 'xml', 'yaml'];
export var codeBlock = function codeBlock(node) {
  var result = '';
  node.forEach(function (n) {
    result += inlines(n, {
      parent: node
    });
  });
  if (supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) {
    return "{code:".concat(node.attrs.language, "}").concat(result, "{code}");
  } else {
    return "{noformat}".concat(result, "{noformat}");
  }
};